module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8Ehez"))).then(() => parcelRequire('hEqeo'));